import React from "react";
import "./Pagination.css";

function Pagination({ pagedata, onPageChange }) {
  const currentPage = Number(pagedata?.currentPage || 1);
  const totalPages = Number(pagedata?.totalPages || 1);
  const pageSize = Number(pagedata?.pageSize || pagedata?.per_page || 10);
  const totalCount = Number(pagedata?.totalCount || pagedata?.total || 0);

  const getPageRangeText = () => {
    if (!totalCount) return "0 results";
    const startRange = (currentPage - 1) * pageSize + 1;
    const endRange = Math.min(currentPage * pageSize, totalCount);

    return `${startRange}-${endRange} of ${totalCount}`;
  };

  return (
    <div className="pagination">
      <p>Showing {getPageRangeText()}</p>
      <div className="paginationbtns">
        <button
          disabled={currentPage <= 1}
          className="pagination_button"
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </button>

        <button className="pagination_activebutton">
          {currentPage}{" "}
        </button>

        <button
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
          className="pagination_button"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default Pagination;
